package com.dotdrives.model
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.time.Instant
import kotlin.time.Duration.Companion.days
@Serializable data class DashboardFinance(
 @SerialName("year_total") val yearTotal:Double,
 @SerialName("retention_base") val retentionBase:Int,
 val retained:Int,
 val goal:Double,
 @SerialName("goal_received") val goalReceived:Double,
 val goals:List<DashboardGoal> = emptyList(),
) {
 val retentionPercent:Double? get()=if(retentionBase>0)100.0*retained/retentionBase else null
 val goalPercent:Double? get()=if(goal>0)100.0*goalReceived/goal else null
}
@Serializable data class DashboardGoal(val id:String,val name:String,val amount:Double,val received:Double,
 @SerialName("starts_at") val startsAt:Instant?=null,@SerialName("ends_at") val endsAt:Instant?=null) {
 fun elapsedFraction(asOf:Instant):Double? {
  val start=startsAt?:return null;val end=endsAt?:return null
  if(end<=start)return null
  return ((asOf-start).inWholeSeconds.toDouble()/(end-start).inWholeSeconds).coerceIn(0.0,1.0)
 }
 fun forecast(asOf:Instant):Double? = elapsedFraction(asOf)?.takeIf { it>0 && amount>0 }?.let { received/it }
 fun expected(asOf:Instant):Double? = elapsedFraction(asOf)?.takeIf { amount>0 }?.let { amount*it }
}
@Serializable data class DashboardSnapshot(
 @SerialName("as_of") val asOf:Instant,
 @SerialName("giver_count") val giverCount:Int,
 @SerialName("active_drives") val activeDrives:Int,
 @SerialName("overdue_count") val overdueCount:Int,
 @SerialName("stale_count") val staleCount:Int,
 @SerialName("unthanked_count") val unthankedCount:Int?=null,
 val finance:DashboardFinance?=null,
)
@Serializable data class DashboardQueueItem(val id:String,val kind:String,
 @SerialName("subject_type") val subjectType:String,@SerialName("subject_id") val subjectId:String,
 val title:String,@SerialName("occurred_at") val occurredAt:Instant)
fun rankDashboardQueue(items:List<DashboardQueueItem>):List<DashboardQueueItem> = items.sortedWith(compareBy<DashboardQueueItem> { when(it.kind){"reminder"->0;"gift"->1;else->2} }.thenBy { it.occurredAt }.thenBy { it.id })
fun dashboardItemDue(item:DashboardQueueItem,asOf:Instant):Boolean=when(item.kind){"drive"->item.occurredAt<asOf-30.days;"reminder"->item.occurredAt<asOf;else->item.occurredAt<=asOf}
